import { useState, forwardRef, useImperativeHandle, useRef } from "react";
import { ViewMode } from "./viewMode";
import './greeting.css'
import { Link } from "react-router-dom";
import { ChildComponentRef } from "./childComponent";
import ContactForm from "./contactForm";

const Contacts = forwardRef((props, ref) => {
    const divRef = useRef<HTMLDivElement | null>(null);
    const [childComponentBrightness, setChildComponentBrightness] = useState<number>(0);
    const [childComponentFontSize, setChildComponentFontSize] = useState<number>(0);
    const [childComponentLocation, setChildComponentLocation] = useState<{x:number, y:number}>({x:0, y:0});
    const [childComponentSize, setChildComponentSize] = useState<{x:number, y:number}>({x:0, y:0});
    const [viewMode, setViewMode] = useState<ViewMode>();
    const [windowSize, setWindowSize] = useState<{width: number, height: number}>();
    const updateChildComponentBrightness = (gb: number) => setChildComponentBrightness(gb);
    const updateChildComponentFontSize = (gfs: number) => setChildComponentFontSize(gfs);
    const updateChildComponentLocation = (gl: {x:number, y:number}) => setChildComponentLocation(gl);
    const updateChildComponentSize = (gs: {x:number, y:number}) => setChildComponentSize(gs);
    const updateViewMode = (vm: ViewMode, width?: number, height?: number) => {
        setViewMode(vm);
        if (width && height) setWindowSize({width, height});
    }
    useImperativeHandle(ref, (): ChildComponentRef => ({
        name: 'Contacts', updateChildComponentBrightness, updateChildComponentLocation, updateChildComponentSize, updateChildComponentFontSize, updateViewMode, divRef
    }));

    const baseSize = 80;
    const border = 20;
    const socialLogoMaxSize = baseSize * 1.25;
    const socialLogoSize = childComponentSize.x >= socialLogoMaxSize * 3 + border * 4 ? socialLogoMaxSize : (childComponentSize.x - border * 4) / 3;

    const headlineText = "Contacts";
    const contactsText = "Feel free to connect with me through my social media links or send me a message using the form below so I can reach out to you via email. I look forward to hearing from you!";
    
    const desktopStyle: React.CSSProperties = {
        position: "fixed",
        top: `${childComponentLocation.y}px`,
        left: `${childComponentLocation.x}px`,
        transform: "translate(-50%, 0%)",
        width: `${childComponentSize.x}px`,
        height: 'auto',
        padding: '0 10px',
        opacity: `${childComponentBrightness}`
    }
    const mobileStyle: React.CSSProperties = {
        position: "fixed",
        top: `${childComponentLocation.y}px`,
        left: `${childComponentLocation.x}px`,
        transform: "translate(-50%, 0%)",
        width: `${childComponentSize.x}px`,
        height: 'auto',
        padding: '0 10px',
        opacity: `${childComponentBrightness}`
    }
    const headlineTextStyle: React.CSSProperties = {
        margin: '0 0 10px 0',
        textAlign: "center",
        color: "white",
        fontFamily: "Roboto Condensed",
        fontWeight: 400,
        fontSize: `${childComponentFontSize + 5}px`,
    }
    const regularTextStyle: React.CSSProperties = {
        margin: '0',
        textAlign: "justify",
        color: "white",
        fontFamily: "Open Sans",
        fontWeight: 300,
        fontSize: `${childComponentFontSize - 8}px`,
    }

    return (
        <div ref={divRef} style={viewMode?.size == 'desktop'? desktopStyle : mobileStyle}>
            <h1 style={headlineTextStyle}>{headlineText}</h1>
            <p style={regularTextStyle}>{contactsText}</p>
            <div className="links-container" style={{height: `${childComponentSize.y}px`, margin: "0"}}>
                <a href="https://www.linkedin.com/in/artem-verkhovsky" className="social"style={{width: `${socialLogoSize}px`, opacity: '0'}}></a>
                <a href="https://t.me/Artem_Verkhovskiy" className="social" style={{width: `${socialLogoSize}px`, opacity: '0'}}></a>
                <a href="https://www.instagram.com/parametric_jam/" className="social" style={{width: `${socialLogoSize}px`, opacity: '0'}}></a>
            </div>
            <ContactForm/>
            <div className="links-container" style={{fontSize: `${childComponentFontSize}px`}}>
                <Link to="/" style={{marginRight: 'auto'}}>{"< Back"}</Link>
                <Link to="/about">About Me</Link>
                <Link to="/cv" style={{marginLeft: 'auto'}}>CV</Link>
            </div>
        </div>
    )
});

export default Contacts